import React from 'react';
import styled from '@emotion/styled';
import { colors } from 'src/theme';
import { i18n } from 'src/common';
import { Text } from 'src/components';

const TERMS_URL = 'https://kompare.hr/uvjeti-koristenja/';
const EMAIL_URL = 'mailto:szop@kompare.hr';
const PRIVACY_URL = 'https://kompare.hr/informacije-o-koristenju-osobnih-podataka/';

const DisclaimerRoot = styled(Text)({
  marginTop: '16px',
});

const DisclaimerLink = styled.a({
  color: colors.text4,
  textDecoration: 'underline',
  cursor: 'pointer',

  '&:hover': {
    color: colors.primary,
  },
});

export const FormDisclaimer: React.FC<{ intro?: boolean }>= ({ intro = false }) => {
  return (
    <DisclaimerRoot type="small" color={colors.text4}>
      {intro &&  <>
        {i18n.t('components.forms.disclaimer.intro')}
          <DisclaimerLink href={TERMS_URL} target="_blank" rel="noopener noreferrer">
            {i18n.t('components.forms.disclaimer.termsLabel')}. 
          </DisclaimerLink>
        </>
      }
      {i18n.t('components.forms.disclaimer.middle')}
      <DisclaimerLink href={EMAIL_URL}>{i18n.t('components.forms.disclaimer.email')}</DisclaimerLink>
      {i18n.t('components.forms.disclaimer.privacyMiddle')}
      <DisclaimerLink href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">
        {i18n.t('components.forms.disclaimer.privacyLabel')}
      </DisclaimerLink>
      {i18n.t('components.forms.disclaimer.end')}
    </DisclaimerRoot>
  );
};
